<template> 
<div v-if="loading" class="spinner-container">
    <div class="spinner"></div>
  </div>
   <div v-else class="app-container">
    <!-- Header -->
    <header class="app-header">
      <div class="header-content">
        <div class="back-button" @click="goBack()">
          <i class="bi bi-arrow-left-circle-fill"></i>
        </div>
        <div class="header-title">
          <h2>{{ language?.student || 'Students' }}</h2>
        </div>
        <div class="header-placeholder"></div>
      </div>
    </header>

    <!-- Main Content -->
    <main class="main-content">
      <!-- Welcome Message -->
      <div class="welcome-section">
        <div class="welcome-content">
          <!--<h3>Hello, Teacher!</h3>-->
          <p>Select a class to see Students List</p>
        </div>
        <!--<div class="welcome-icon">-->
        <!--  <i class="bi bi-journal-bookmark"></i>-->
        <!--</div>-->
      </div>

      <!-- Class List -->
      <div class="class-list">
        <div class="class-grid">
          <div 
            v-for="(item, i) in classlist" 
            :key="i" 
            class="class-card"
            @click="attendence(item.id)"
          >
            <div class="class-card-content">
              <div class="class-icon">
                <i class="bi bi-mortarboard"></i>
              </div>
              <div class="class-details">
                <h3>{{ item.name }}</h3>
                <p><i class="bi bi-people-fill"></i> {{ item.std_cnt }} Students</p>
              </div>
              <div class="class-arrow">
                <i class="bi bi-arrow-right-circle-fill"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div v-if="classlist.length === 0" class="empty-state">
        <div class="empty-icon">
          <i class="bi bi-inbox"></i>
        </div>
        <h3>No Classes Available</h3>
        <p>Add classes to get started with attendance</p>
      </div>
    </main>
  </div>
 
 
</template>
 <style scoped>
.app-container {
  min-height: 100vh;
  background: #f5f7fa;
}

.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #0056c2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.app-header {
  background: linear-gradient(135deg, #0056c2 0%, #003a75 100%);
  color: white;
  padding: 16px;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.back-button {
  font-size: 24px;
  cursor: pointer;
}

.header-title h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}

.header-placeholder {
  width: 24px; /* For balance */
}

.main-content {
  padding: 20px 16px;
}

.welcome-section {
  background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
  border-radius: 16px;
  padding: 20px;
  color: white;
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.welcome-content h3 {
  margin: 0 0 8px;
  font-size: 20px;
}

.welcome-content p {
  margin: 0;
  opacity: 0.9;
}

.welcome-icon {
  font-size: 40px;
  opacity: 0.8;
}

.class-list {
  margin-bottom: 80px;
}

.class-grid {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.class-card {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  cursor: pointer;
}

.class-card:active {
  transform: scale(0.98);
}

.class-card-content {
  display: flex;
  align-items: center;
  padding: 20px;
}

.class-icon {
  width: 50px;
  height: 50px;
  background: rgba(0, 86, 194, 0.1);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  font-size: 24px;
  color: #0056c2;
}

.class-details {
  flex: 1;
}

.class-details h3 {
  margin: 0 0 6px;
  font-size: 18px;
  color: #2c3e50;
  font-weight: 600;
}

.class-details p {
  margin: 0;
  font-size: 14px;
  color: #7f8c8d;
}

.class-arrow {
  font-size: 24px;
  color: #0056c2;
}

.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #7f8c8d;
}

.empty-icon {
  font-size: 60px;
  margin-bottom: 16px;
  opacity: 0.5;
}

.empty-state h3 {
  margin: 0 0 8px;
  font-size: 20px;
}

.empty-state p {
  margin: 0;
  font-size: 14px;
}

@media (max-width: 480px) {
  .welcome-section {
    flex-direction: column;
    text-align: center;
    gap: 16px;
  }
  
  .class-card-content {
    padding: 16px;
  }
  
  .class-icon {
    width: 44px;
    height: 44px;
    font-size: 20px;
  }
}
</style>
<script> 
import axios from "@/plugins/axios";  

export default {
  name: 'Branch',
  components: { 
  },
  mounted() { 
   //  this.fetchWeather();
    this.getBranches(); // Call the method here
    
},
  data() {
    return { 
      loading:false,
      error:null,
      isUserLogged:false,
      user_details:[],
      language: this.getLocalStorageArray('lang'),
      addclass:{
         name:'',
         status:1
      },
      classlist:[], 
      branch_name:'',

    }
  },
  methods:{
    initializeHomeContent(){
    

    },
    goBack() {
          
          this.$router.go(-1);
  },
  goprevious() {
          
          this.$router.go("/branch");
  },

 
  
    async getBranches() {
        this.loading = true;
        this.error = null;
  
        try {
           var self=this;
            axios.post("getaddclass").then((response) => {
               self.classlist=response.data.classlist;
               self.language=response.data.language;
               localStorage.setItem('lang',response.data.language);
        
          }).then(() => {
               self.initializeHomeContent();
          }).catch((err) => {
            
          });;
         

        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      }, 





       addClass() {
        this.loading = true;
        this.error = null;
  
        try {
           var self=this;
           if(self.addclass.name == ''){


             self.$swal.fire("Name is Required!");


           }else{



         
            axios.post("addclass",self.addclass).then((response) => {
              
                        self.classlist=response.data.classlist;
                        self.language=response.data.language;
                     self.$swal.fire(response.data.message);
                     if(response.data.success)
                     {
                        self.branch={ name:'',         address:'',contact:'',};
                     }
                     window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("branch")).hide();
                      

               
        
          }).then(() => {
               self.initializeHomeContent();
          }).catch((err) => {
            
          });;
           }

        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      }, 


      editBranch(editBranch) {
         window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("branch")).show();
         this.addclass=editBranch;
      }, 





      deleteaddclass(id = "") {
    this.loading = true;
    this.error = null;

    try {
        var self = this;

        this.$swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, cancel",
        }).then((result) => {
            if (result.isConfirmed) {
                axios.post("deleteaddclass", { id: id }).then((response) => {
                     self.classlist=response.data.classlist;
                    self.$swal.fire(response.data.message);
                    
                    if (response.data.success) {
                        window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("branch")).hide();
                    }
                }).then(() => {
                    self.initializeHomeContent();
                }).catch((err) => {
                    self.$swal.fire("Error!", "Something went wrong.", "error");
                });
            }
        });

    } catch (err) {
        this.error = err.response?.data?.message || "Login failed. Please try again.";
    } finally {
        this.loading = false;
    }
},

        getLocalStorageArray(key) {
                let data = localStorage?.getItem(key);
                try {
                    return data ? JSON.parse(data) : [];
                } catch (e) {
                    console.error("Error parsing localStorage data", e);
                    return [];
                }
            }
,



attendence(id){
    this.$router.push('AddStudent?id='+id);
}














  }
}






</script>
